import { bProfile, ProfileRole, useProfile } from "@brg/auth"
import { Dropdown, DropdownListItem, FlexBox, useToasts } from "@brg/ui"
import { useTranslation } from "react-i18next";
import { IconWrapperSpecial2 } from "shared/assets/styles";
import MoreIcon from "shared/icons/MoreIcon";
import { FC, useCallback, useMemo } from 'react';
import { ButtonsWrapper } from "shared/pages/project/components/ProjectButtons"
import { AppTester } from "supporting";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import { API, Endpoints, Team } from "@brg/api";
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { downloadPDF } from "shared/components/PrintProject/model/downloadPDF";
import { HsePolicies } from "shared/constants/HsePolicies";

export const TeamTempButtons: FC<{ team: ComputedTeam }> = ({ team }) => {
    const profile = useProfile();
    const history = useHistory();
    const isGeo = AppTester.isGeograffee();
    const toasts = useToasts();
    const { t, i18n } = useTranslation();

    const isSuperModer = useMemo(() => (profile && bProfile.isModer(profile)), [profile]);
    const isOwner = useMemo(() => profile && team && team?.ownersIDs?.includes(profile?.accountId), [team, profile])

    const hasCurrentUnitAdminPolicy = useMemo(() => profile && team?.teamId && profile.rolesList && Array.isArray(profile.rolesList)
            && (new ProfileRole(`${HsePolicies.admin_unit_prefix}${team.teamId}`)).containsIn(profile.rolesList), [team, profile]);    
    const hasAllUnitsAdminPolicy = useMemo(() => profile && profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_ui_units_admin)).containsIn(profile.rolesList), [profile]);

    const editFn = (() => {
        if (isSuperModer || isOwner || hasAllUnitsAdminPolicy || hasCurrentUnitAdminPolicy) {
          history.push(CreateLinkTo.teamEdit(team?.teamId ?? 'undefined') + '?tab=lg');
        }
    })
    
    const printPDFForm = useMemo(() => ({
        orientation: true,
        localization: i18n.language,
        teamId: team?.teamId,
        isPresentation: true,
    }), [team, i18n.language]);

    const printPdfCard = useCallback(() => {
    
        toasts.info(`${t('print_project_toast')} ${isOwner? t('print_project_toast') : team.name} `)
        // console.log(team)
    
        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Team/PrintPdf')
            .post()
            .body(printPDFForm)
            .send()
            .then((r) => r.json())
            .then((r) => {  
                return r?.length > 0 ? downloadPDF(r, team?.name, toasts.error, toasts.info, t) : console.error('no files')
            })
            .catch((e) => console.error(e))
    }, [printPDFForm, t]);

    const formButton = team?.buttons?.find?.(
        (btn: any) =>  typeof btn.href === 'string' && btn.href.match(/\/form\/[a-zA-Z0-9]+$/)
    );
    let formId: string | null = null;
    if (formButton) {
        const match = formButton.href.match(/\/form\/([a-zA-Z0-9]+)/);
        if (match) {
            formId = match[1];
        }
    }

    const handleFormTableClick = () => {
        if (formId) {
            history.push(`/teams/form_data/${formId}`);
        }
    };

    if (!(isSuperModer || isOwner || hasAllUnitsAdminPolicy || hasCurrentUnitAdminPolicy)) {
        return null;
    }

    return (
        <FlexBox>
            <ButtonsWrapper>
                {!!profile && (
                    <Dropdown
                    offsetY={5}
                    offsetX={-140}
                    dark={isGeo}
                    hideArrow 
                        target={
                            <IconWrapperSpecial2>
                                <MoreIcon />
                            </IconWrapperSpecial2>
                        }
                    >
                        <DropdownListItem onClick={editFn}>{t('edit').toLowerCase()}</DropdownListItem>
                        <DropdownListItem onClick={printPdfCard}>{t('print_project').toLowerCase()}</DropdownListItem>
                        {formId && (
                            <DropdownListItem onClick={handleFormTableClick}>
                                {t('form_table').toLowerCase()}
                            </DropdownListItem>
                        )}
                    </Dropdown>
                )}
            </ButtonsWrapper>
        </FlexBox>
    )
}import { bProfile, ProfileRole, useProfile } from "@brg/auth"
import { Dropdown, DropdownListItem, FlexBox, useToasts } from "@brg/ui"
import { useTranslation } from "react-i18next";
import { IconWrapperSpecial2 } from "shared/assets/styles";
import MoreIcon from "shared/icons/MoreIcon";
import { FC, useCallback, useMemo } from 'react';
import { ButtonsWrapper } from "shared/pages/project/components/ProjectButtons"
import { AppTester } from "supporting";
import { useHistory } from "react-router-dom";
import { CreateLinkTo } from "shared/constants/linkTo";
import { API, Endpoints, Team } from "@brg/api";
import { ComputedTeam } from "shared/helpers/types/computed/ComputedTeam";
import { downloadPDF } from "shared/components/PrintProject/model/downloadPDF";
import { HsePolicies } from "shared/constants/HsePolicies";

export const TeamTempButtons: FC<{ team: ComputedTeam }> = ({ team }) => {
    const profile = useProfile();
    const history = useHistory();
    const isGeo = AppTester.isGeograffee();
    const toasts = useToasts();
    const { t, i18n } = useTranslation();

    const isSuperModer = useMemo(() => (profile && bProfile.isModer(profile)), [profile]);
    const isOwner = useMemo(() => profile && team && team?.ownersIDs?.includes(profile?.accountId), [team, profile])

    const hasCurrentUnitAdminPolicy = useMemo(() => profile && team?.teamId && profile.rolesList && Array.isArray(profile.rolesList)
            && (new ProfileRole(`${HsePolicies.admin_unit_prefix}${team.teamId}`)).containsIn(profile.rolesList), [team, profile]);    
    const hasAllUnitsAdminPolicy = useMemo(() => profile && profile.rolesList && Array.isArray(profile.rolesList)
        && (new ProfileRole(HsePolicies.access_ui_units_admin)).containsIn(profile.rolesList), [profile]);

    const editFn = (() => {
        if (isSuperModer || isOwner || hasAllUnitsAdminPolicy || hasCurrentUnitAdminPolicy) {
          history.push(CreateLinkTo.teamEdit(team?.teamId ?? 'undefined') + '?tab=lg');
        }
    })
    
    const printPDFForm = useMemo(() => ({
        orientation: true,
        localization: i18n.language,
        teamId: team?.teamId,
        isPresentation: true,
    }), [team, i18n.language]);

    const printPdfCard = useCallback(() => {
    
        toasts.info(`${t('print_project_toast')} ${isOwner? t('print_project_toast') : team.name} `)
        // console.log(team)
    
        API.request()
            .endpoint(Endpoints.geograffee)
            .url('/api/Team/PrintPdf')
            .post()
            .body(printPDFForm)
            .send()
            .then((r) => r.json())
            .then((r) => {  
                return r?.length > 0 ? downloadPDF(r, team?.name, toasts.error, toasts.info, t) : console.error('no files')
            })
            .catch((e) => console.error(e))
    }, [printPDFForm, t]);

    const formButton = team?.buttons?.find?.(
        (btn: any) =>  typeof btn.href === 'string' && btn.href.match(/\/form\/[a-zA-Z0-9]+$/)
    );
    let formId: string | null = null;
    if (formButton) {
        const match = formButton.href.match(/\/form\/([a-zA-Z0-9]+)/);
        if (match) {
            formId = match[1];
        }
    }

    const handleFormTableClick = () => {
        if (formId) {
            history.push(`/teams/form_data/${formId}`);
        }
    };

    if (!(isSuperModer || isOwner || hasAllUnitsAdminPolicy || hasCurrentUnitAdminPolicy)) {
        return null;
    }

    return (
        <FlexBox>
            <ButtonsWrapper>
                {!!profile && (
                    <Dropdown
                    offsetY={5}
                    offsetX={-140}
                    dark={isGeo}
                    hideArrow 
                        target={
                            <IconWrapperSpecial2>
                                <MoreIcon />
                            </IconWrapperSpecial2>
                        }
                    >
                        <DropdownListItem onClick={editFn}>{t('edit').toLowerCase()}</DropdownListItem>
                        <DropdownListItem onClick={printPdfCard}>{t('print_project').toLowerCase()}</DropdownListItem>
                        {formId && (
                            <DropdownListItem onClick={handleFormTableClick}>
                                {t('form_table').toLowerCase()}
                            </DropdownListItem>
                        )}
                    </Dropdown>
                )}
            </ButtonsWrapper>
        </FlexBox>
    )
}